export default __webpack_public_path__ + "static/media/image-placeholder.ce927d4c.png";